// @ts-nocheck

import styled, { css } from 'styled-components';

export const SignalLevel = styled.div.withConfig({ displayName: "styles__SignalLevel", componentId: "sc-w72raz-0" })(["width:1px;background:#adb8c3;border-radius:1px;", ";", ""],



(props) =>
props.height &&
css(["height:", ";"],
props.height),

(props) =>
props.active &&
css(["background:#27ae60;"]));




export const Wrapper = styled.div.withConfig({ displayName: "styles__Wrapper", componentId: "sc-w72raz-1" })(["display:flex;align-items:flex-end;& ", "{margin-right:2px;}& ", ":last-child{margin-right:0;}"],


SignalLevel,


SignalLevel);
